// frontend/src/components/Footer.jsx
import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="footer-text">
          © Copyright {currentYear} 
          <a 
            href="https://buildint.ai" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="footer-link"
          >
            <i className="bi bi-link-45deg"></i> BuildINT
          </a>
          . All Rights Reserved
        </p>
        <span className="footer-text">|</span>
        <p className="footer-text">
          Designed by 
          <a 
            href="https://buildint.ai" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="footer-link"
          >
            BuildINT
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;